module.exports = __webpack_public_path__ + "img/OUTER.5929465f.jpg";